import { call, put, takeEvery } from "redux-saga/effects";
import { apiWrapper } from "../../../api/apiWrapper";
import { IBaseResponeModel } from "../../../models/response/base-response";
import { eDiemDanhActionTypeIds, IDiemDanhPhongNamHocStart, IDiemDanhSelectPhongNamHocStart } from "../../action-types/diem-danh/IDiemDanhActionTypes";

import { actions } from "../../actions/actionsWrapper";

const diemDanhApi = apiWrapper.diemDanh;

export function* diemDanhSaga(): any {
    yield takeEvery(eDiemDanhActionTypeIds.DIEMDANH_PHONGNAMHOC_START, diemDanhPhongNamHocWorker)
    yield takeEvery(eDiemDanhActionTypeIds.SELECT_PHONGNAMHOC_START, selectPhongNamHocWorker)
}

function* selectPhongNamHocWorker(data: IDiemDanhSelectPhongNamHocStart): any {
    const res: IBaseResponeModel = yield call([diemDanhApi, diemDanhApi.SelectByPhongNamHocAsync], data.payload)
    if (res.is_success) {
        yield put(actions.diemDanh.selectPhongNamHocSuccess(res.data))
    } else {
        yield put(actions.diemDanh.selectPhongNamHocError(res.message || "Không tải được danh sách học sinh"))
    }
}
function* diemDanhPhongNamHocWorker(action: IDiemDanhPhongNamHocStart): any {
    const res: IBaseResponeModel = yield call([diemDanhApi, diemDanhApi.DiemDanhPhongNamHocAsync], action.payload)
    if (res.is_success) {
        yield put(actions.diemDanh.diemDanhPhongNamHocSuccess())
        yield put(actions.diemDanh.showDiemDanhModal(false))
    } else {
        yield put(actions.diemDanh.diemDanhPhongNamHocError(res.message || "Không lưu được điểm danh"))
        yield put(actions.diemDanh.showDiemDanhModal(false))
    }
}